import React, { useState, Fragment, useRef, useEffect } from 'react';
import './CityPicker.css';

const CityPicker = ({ value = '', handleChange, cities = [] }) => {
  const [query, setQuery] = useState(value);
  const [list, setList] = useState(cities);
  const inputEl = useRef(null);

  useEffect(() => {
    inputEl.current.focus();
  }, []);
  const handleQuery = value => {
    const query = value.trim().toLowerCase();
    const filteredCities = [];

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < cities.length; index++) {
      const section = cities[index];

      const filtered = section.cities.filter(city => city.name.toLowerCase().startsWith(query));
      if (filtered.length) {
        filteredCities.push({
          title: section.title,
          cities: filtered,
        });
      }
    }

    setQuery(value);
    setList(filteredCities);
  };

  return (
    <div className="citypicker_container">
      <input
        ref={inputEl}
        placeholder="Enter City"
        className="citypicker_input"
        type="text"
        onChange={event => handleQuery(event.target.value)}
        value={query}
      />
      <div className="citypicker_list">
        {list.map(section => (
          <Fragment key={section.title}>
            <div className="citypicker_title">{section.title}</div>
            <ul id="fromCityPicker">
              {section.cities.map((city, index) => (
                <li key={index} onClick={() => handleChange(city)}>
                  {city.name}
                </li>
              ))}
            </ul>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default CityPicker;
